import React, { ReactElement } from 'react'
import styled from 'styled-components'

import { FieldPrefix } from '../../../../1stlog-ui/src/components/Field'
import FieldArray from '../../../../1stlog-ui/src/components/FieldArray'
import ListGroup, {
  ListGroupItem,
} from '../../../../1stlog-ui/src/components/ListGroup'
import { TOrder } from '../../../../1stlog-ui/src/components/OrderDetails/helpers'
import Coli from './Coli'

type TColisProps = {
  cancelColi: (id: string) => void
  order: TOrder
}

const ListGroupItemCustom = styled(ListGroupItem)`
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  // margin-bottom: -5px;
`

const Colis = (props: TColisProps): ReactElement => {
  const { cancelColi, order } = props

  return (
    <>
      <div className="">
        <FieldArray name="colis">
          {({ fields }) => (
            <ListGroup flush>
              {fields.map((name: string, index: number) => (
                <ListGroupItemCustom key={name}>
                  <FieldPrefix prefix={name} overwritePrefix>
                    <Coli index={index} cancelColi={cancelColi} order={order} />
                  </FieldPrefix>
                </ListGroupItemCustom>
              ))}
            </ListGroup>
          )}
        </FieldArray>
      </div>
    </>
  )
}

export default Colis
